import * as React from 'react';

import { DatesPicker } from 'features/search-widget';

interface DatesProps {
  customStartLabel?: string;
  customEndLabel?: string;
}
function Dates({ customStartLabel, customEndLabel }: DatesProps): JSX.Element {
  return (
    <section className="dates">
      <DatesPicker customStartLabel={customStartLabel} customEndLabel={customEndLabel} />
    </section>
  );
}

export { Dates };
